import { createContext, useContext } from "react";
import { TryOnMode, ZakekeTryOnExposedMethods } from "../components/tryon/tryOnModels";


export interface ZakekeTryOnContext {
    tryon: ZakekeTryOnExposedMethods;
    setTryon: (tryon: ZakekeTryOnExposedMethods) => void;
    tryOnPickedMode: TryOnMode;
    setTryOnPickedMode: (mode: TryOnMode) => void;
    tryOnVisibility: boolean;
    setTryOnVisibility: (visibility: boolean) => void;
}

export const TryOnContext = createContext<ZakekeTryOnContext>({
    tryon: {} as ZakekeTryOnExposedMethods,
    setTryon: (tryon: ZakekeTryOnExposedMethods) => { },
    tryOnPickedMode: TryOnMode.TryOn,
    setTryOnPickedMode: (mode: TryOnMode) => { },
    tryOnVisibility: false,
    setTryOnVisibility: (visibility: boolean) => { },
});

export const useZakekeTryOn = () => {
    const value = useContext(TryOnContext);

    if (!value)
        throw new Error('Invalid Zakeke TryOn state. Ensure you have wrapped your component with the ZakekeProvider component and you are not calling useZakekeTryOn outside of it.');

    return value;
}
